module.exports = __webpack_public_path__ + "static/media/edit.1d786d1b.svg";